'use client';

import { useEffect } from 'react';
import { redirect } from 'next/navigation';
import { IHospitalInfo, useHospitalStore } from '../../../stores';
import { EpStarter } from '../../../templates';
import { ROUTE_HOMEPAGE } from '../../../constants/urlConstants';

interface PSNotificationProps {
    searchParams: IHospitalInfo;
}

const PSNotificationContent = ({ searchParams }: PSNotificationProps) => {
    const { addHospitalInfo } = useHospitalStore((state) => state);
    const params = searchParams;
    const hasNoParams = Object.keys(params).length === 0;

    useEffect(() => {
        if (params) {
            addHospitalInfo(params);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params]);

    if (hasNoParams) {
        return redirect(ROUTE_HOMEPAGE);
    }

    return (
        <EpStarter.Root>
            <EpStarter.Header />
            <EpStarter.Content
                tag={'PSNotification'}
                template={'public-patient-safety'}
            />
            <EpStarter.Footer />
        </EpStarter.Root>
    );
};

export default PSNotificationContent;
